module.exports = __webpack_public_path__ + "media/flags/ng-e6413d37.svg";